import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { CreateTeam } from "@pages/members/teams/create-team";
import { TEAM_DISPLAY_NAME, TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { MembersDuoIcon, SearchDuoIcon, XMarkCircleFillIcon } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
import { getSvgColoredIconCss } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Empty page content for teams table */
export function TeamsEmptyPage(t0) {
  const $ = _c(4);
  const {
    status,
    isFiltering: t1
  } = t0;
  const isFiltering = t1 === undefined ? false : t1;
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  if (isFiltering && status !== "rejected") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="No results found" subtitle={`There are no ${TEAMS_DISPLAY_NAME} that match the filters.`} icon={SearchDuoIcon} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (debouncedSearchText.length) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="No results found" subtitle={`There are no ${TEAMS_DISPLAY_NAME} that match this search.`} icon={SearchDuoIcon} />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (status === "rejected") {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="Error" subtitle={`Failed to fetch the ${TEAMS_DISPLAY_NAME}. Please reload the page and try again.`} icon={_temp} />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EmptyPage title={`You don't have any ${TEAMS_DISPLAY_NAME} yet`} subtitle={`You haven't added ${TEAMS_DISPLAY_NAME} to your workspace. Select the "new ${TEAM_DISPLAY_NAME}" button to create one.`} icon={MembersDuoIcon} button={<CreateTeam variant="primary" />} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp() {
  return <XMarkCircleFillIcon sx={{
    ...getSvgColoredIconCss(PALETTE_VARS.error.main),
    width: "61px",
    height: "61px"
  }} />;
}